import localforage from 'localforage';
import { httpX } from 'src/plugins/http';
import { update } from 'src/permission';
import { resetCache } from '@/helpers/api';

export const attemptLogin = ({ dispatch }, payload) => (
  httpX.post('/auth', payload)
    .then(({ data }) => {
      const { user, token } = data;

      dispatch('setUser', user);
      dispatch('setToken', token);
      dispatch('setModule', 'clinical');

      return user;
    })
);

export const resetAuthState = async ({ dispatch }) => {
  dispatch('setUser', null);
  dispatch('setToken', null);
  dispatch('setModule', null);
  dispatch('stopHeartbeat');
  resetCache();
};

export const logout = async ({ dispatch }) => {
  await Promise.all([
    httpX.post('/logout'),
    dispatch('resetAuthState'),
  ]);
};

export const setUser = ({ commit, dispatch }, user) => {
  commit('Auth.SET_USER', user);
  update((
    user && user.branch && Array.isArray(user.branch.actions)
      ? user.branch.actions
      : []
  ));
  if (user && user.branch) {
    if (!user.branch.settings) {
      user.branch.settings = {};
    }
    if (!('clinical.blockServiceWithoutAccount' in user.branch.settings)) {
      user.branch.settings['clinical.blockServiceWithoutAccount'] = false;
    }
    dispatch('startHeartbeat');
  }
  return Promise.resolve(user);
};

export const startHeartbeat = ({ commit }) => {
  const intervalId = setInterval(() => {
    httpX.post('/sessions/heartbeat').catch(() => {});
  }, 1000 * 60);
  commit('Auth.SET_HEARTBEAT_INTERVAL_ID', intervalId);
};

export const stopHeartbeat = ({ commit, state }) => {
  clearInterval(state.heartbeatIntervalId);
  commit('Auth.SET_HEARTBEAT_INTERVAL_ID', null);
};

export const setToken = ({ commit }, token) => {
  commit('Auth.SET_TOKEN', token);
  return Promise.resolve(token);
};

export const setModule = ({ commit }, module) => {
  commit('Auth.SET_MODULE', module);
  return Promise.resolve(module);
};

export const checkUserToken = ({ dispatch, state }) => {
  if (state.token) {
    return Promise.resolve(state.token);
  }

  return Promise.all([
    localforage.getItem('token'),
    localforage.getItem('module').catch(() => 'clinical'),
  ])
    .then(([token, module]) => {
      if (!token) {
        return Promise.reject(new Error('NO_TOKEN'));
      }

      dispatch('setModule', module);

      return dispatch('setToken', token);
    })
    .then(() => dispatch('loadUser'));
};

export const loadUser = ({ dispatch }) => (
  httpX.get('/me')
    .then(({ data }) => dispatch('setUser', data))
    .catch(() => {
      dispatch('logout');
      return Promise.reject(new Error('FAIL_IN_LOAD_USER'));
    })
);
